// components/ResponsiveNoCardFound.jsx
import React from "react";
import mobileImg from "../assets/card_not_found_sm.png";
import desktopImg from "../assets/card_not_found.png";

export default function ResponsiveNoCardFound() {
  return (
    <picture>
      <source media="(max-width: 768px)" srcSet={mobileImg} />
      <source media="(min-width: 769px)" srcSet={desktopImg} />
      <img src={desktopImg} alt="No card found" className="w-full h-auto object-cover" />
    </picture>
  );
}